import { createSelector } from 'reselect'

import { get, includes, isNil, omitBy } from 'lodash/fp'
import DEFAULT from 'core/data-model/constants/defaults'
import { getAppConfig } from 'deploy-env/app-config'
import { getToggles } from 'quick-quote/feature-toggles'

import { filterValidateLicense } from 'core/service/distributor/permission'
import { isAmloApplicable, isCheckAmloEnabled } from 'identity/amlo'

export const getIdentityProfileImage = (state) => {
  if (state.identity.user.type === 'Authenticated') return state.identity.user.profile.user_image
  return undefined
}

export const getIdentityProfile = (state) => {
  if (state.identity.user.type === 'Authenticated') return state.identity.user.profile
  else return undefined
}
export const getIdentityUser = (state) => state.identity.user
export const getUserAgentCode = (state) => {
  const user = state.identity.user
  if (user.type === 'Authenticated') return user.profile.agent_code
  return undefined
}
// $$FlowFixMe
export const getUserAgentType = (state) => get('identity.user.profile.agent_type')(state) || DEFAULT.DEFAULT_AGENT_TYPE
export const isLoggedIn = (state) => state.identity.user.type === 'Authenticated'
export const getUserDistributorGroup = (state) => state.identity.user.distributorGroup

export const isBancAgent = (state) =>
  state.identity.user.distributorGroup === 'BANC' && state.identity.user.type === 'Authenticated'

export const getIsAgent = (state) =>
  state.identity.user.distributorGroup === 'AGENT' && state.identity.user.type === 'Authenticated'

export const isAllowIproMenu = (state) => {
  const allowedUserType = getAppConfig().ALLOWED_IPRO_MENU
  return getToggles().ENABLE_OPTY_MENU && isLoggedIn(state) && includes(getUserAgentType(state))(allowedUserType)
}

export const isAllowOptionalIHealtyUltra = (state) => {
  const allowedUserType = getAppConfig().ALLOWED_OPTIONAL_IHEALTHY_ULTRA
  return (
    getToggles().ENABLE_OPTIONAL_IHEALTHY_ULTRA &&
    isLoggedIn(state) &&
    includes(getUserAgentType(state))(allowedUserType)
  )
}

export const isAllowReviseQQMenu = (state) => {
  const allowedUserType = getAppConfig().ALLOWED_REVISE_QQ_MENU
  return getToggles().ENABLE_REVISE_FNA && isLoggedIn(state) && includes(getUserAgentType(state))(allowedUserType)
}
export const isNewAsteriskOfSummaryMainContract = (state) => {
  const allowedUserTypeNewAsterisk = getAppConfig().ALLOWED_NEW_ASTERISK_OF_SUMMARY_MAIN_CONTRACT
  return (
    getToggles().ENABLE_NEW_ASTERISK_OF_SUMMARY_MAIN_CONTRACT &&
    isLoggedIn(state) &&
    includes(getUserAgentType(state))(allowedUserTypeNewAsterisk)
  )
}

export const isAllowMwpMenu = (state) => {
  const allowedUserType = getAppConfig().ALLOWED_MWP_MENU
  return getToggles().ENABLE_MWP_MENU && isLoggedIn(state) && includes(getUserAgentType(state))(allowedUserType)
}

export const getSelectedFSE = (state) => (isBancAgent(state) ? state.identity.user.fse : undefined)

export const getSelectedOffice = (state) => (isBancAgent(state) ? state.identity.user.office : undefined)

export const getDistributorGroups = (state) => state.distributorGroups.payload
export const getDistributorGroupsStatus = (state) => state.distributorGroups.status

export const getStaffId = (state) => state.identity.user.staffId || ''
export const getStaffName = (state) => state.identity.user.staffName || ''
export const getStaffSurname = (state) => state.identity.user.staffSurname || ''
export const getStaffPosition = (state) => state.identity.user.staffPosition || ''

export const getValidUserLicenses = (state) => filterValidateLicense(state.identity.user.registrations || [])

export const getStaffInfo = createSelector(
  getStaffId,
  getStaffName,
  getStaffSurname,
  getStaffPosition,
  (id, name, surname, position) => ({ id, name, surname, position })
)

export const getIdentityUserAdvisor = (state) => get('identity.user.advisor')(state) || null

export const getAmloStatus = (state) => get('identity.amlo')(state) || { checked: false, hasAccess: true, reason: null }

export const isAmloBlocked = (state) => {
  if (!isCheckAmloEnabled()) {
    return false
  }

  if (!isAmloApplicable(getUserAgentType(state))) {
    return false
  }

  const amlo = getAmloStatus(state)
  return amlo.checked === true && amlo.hasAccess === false
}

export const getAgent = createSelector(
  getIdentityProfile,
  getSelectedFSE,
  getSelectedOffice,
  isBancAgent,
  (profile, fse, office, isBanc) => {
    // Replace fse with LB advisorId to link app to LB
    if (isBanc && fse) {
      fse.advisorId = profile.agent_code
    }

    return omitBy(isNil, {
      ...fse,
      ...office,
      isBanc,
    })
  }
)
